import { MachineApprovalStatusTableActions } from "./MachineApprovalStatusTableActions";

export const getMachineApprovalStatusTableColumns = () => {
  return [
    {
      header: "ID",
      id: "ID",
      accessorKey: "id",
      size: 60,
      cell: ({ row }) => (
        <p style={{ fontWeight: "bold" }}>{row.original.id}</p>
      ),
    },
    {
      header: "Name",
      id: "Name",
      accessorKey: "name",
      size: 200,
    },
    {
      header: null,
      id: "Actions",
      accessorKey: "actions",
      enableSorting: false,
      enableResizing: false,
      size: 60,
      meta: {
        isDisplay: true,
      },
      cell: ({ row }) => (
        <MachineApprovalStatusTableActions original={row.original} />
      ),
    },
  ];
};

export const getMachineApprovalStatusTableFilters = () => {
  return [];
};
